<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.ExpenseType.TitleForm"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-9">
          <label><small class="text-danger" v-if="form.nome.required">*</small>{{$lang.ExpenseType.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="$lang.ExpenseType.PlaceholderEnterName"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          @keypress="onToUpper($event, form.nome)"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger" v-if="form.forma.required">*</small> {{$lang.ExpenseType.LabelApplicationType}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.forma.value" :options="form.forma.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="0">{{$lang.ExpenseType.Option.Debit}}</option>
                <option :value="1">{{$lang.ExpenseType.Option.Credit}}</option>
                <option :value="2">{{$lang.ExpenseType.Option.DoNotCount}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger" v-if="form.exibirEmReembolsoGeral.required">*</small> {{$lang.ExpenseType.LabelViewTravelRefund}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.exibirEmReembolsoGeral.value" :options="form.exibirEmReembolsoGeral.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger" v-if="form.exibirEmDiversos.required">*</small> {{$lang.ExpenseType.LabelViewMiscellaneousExpenses}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.exibirEmDiversos.value" :options="form.exibirEmDiversos.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger" v-if="form.exibirEmViagemAdm.required">*</small> {{$lang.ExpenseType.LabelViewADMTravelExpense}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.exibirEmViagemAdm.value" :options="form.exibirEmViagemAdm.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger" v-if="form.categoria.required">*</small> {{$lang.ExpenseType.LabelCategory}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.categoria.value" :options="form.categoria.options" v-bind:disabled="form.exibirEmViagemAdm.value === true ? false : true">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="1">{{$lang.ExpenseType.Option.MySelf}}</option>
                <option :value="2">{{$lang.ExpenseType.Option.WithVehicle}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.ExpenseType.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.descricao.value"
                      :placeholder="$lang.ExpenseType.PlaceholderEnterDescription"
                      :rows="form.descricao.rows"
                      :size="form.descricao.maxlength"
                      :noResize="form.descricao.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
            :columns="[
              $lang.ExpenseType.DataTable.Name,
              $lang.ExpenseType.DataTable.TravelRefund,
              $lang.ExpenseType.DataTable.TravelExpense,
              $lang.ExpenseType.DataTable.MiscellaneousExpenses,
              $lang.ExpenseType.DataTable.Category,
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.exibirEmReembolsoGeral ? $lang.Common.Yes : $lang.Common.No" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.exibirEmViagemAdm ? $lang.Common.Yes : $lang.Common.No" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.exibirEmDiversos ? $lang.Common.Yes : $lang.Common.No" />
        <TableColumn :IsText="true"   v-if="obj.categoria && obj.categoria == 1"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="'PESSOAL'" />
        <TableColumn :IsText="true"   v-else-if="obj.categoria && obj.categoria == 2"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="'COM VEÍCULO'" />
        <TableColumn :IsText="true"   v-else  v-on:Edit="onEdit(obj)" :status="obj.status" :value="''" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import ExpenseType from './expensetype.js'
export default ExpenseType
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/expensetype/expensetype.vue